/* eslint-disable */

let currentFontSize = null;
let callbacks = [];
let observerStarted = false;

export const FontUtils = {
    
    init() {
        if (observerStarted) return;

        currentFontSize = document.documentElement.getAttribute("data-font-size");

        const observer = new MutationObserver(() => {
            currentFontSize = document.documentElement.getAttribute("data-font-size");

            // powiadom wszystkie komponenty, które się zasubskrybowały
            callbacks.forEach(cb => cb(currentFontSize));
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-font-size"]
        });

        observerStarted = true;
    },

    /**
     * Zwraca aktualny rozmiar fontu
     */
    getFontSize() {
        if (!observerStarted) this.init();
        return currentFontSize;
    },

    /**
     * Pozwala komponentom subskrybować zmiany font-size
     * @param callback (fontSize) => {}
     */
    onChange(callback) {
        if (!observerStarted) this.init();
        callbacks.push(callback);

        // zwracamy funkcję unsubscribe
        return () => {
            callbacks = callbacks.filter(cb => cb !== callback);
        };
    }
};
